'use client';

import Loader from '@pickleballinc/features/src/Loader/Loader';
import getCDNURL from '@pickleballinc/ui/components/global/utils/getCDNURL';

import { useGetGroupsQueryData } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/matchdate/[matchDateId]/queries';
import GroupsComponent from '@/modules/league/new-components/groups-components/GroupsComponent/GroupsComponent';
import { GameDayInfo } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';

interface GroupsContentProps {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  userSession?: Session;
  currentSequenceNumber: number;
  isAuthorized: boolean;
}

const GroupsContent = ({
  params,
  headerContent,
  userSession,
  currentSequenceNumber,
  isAuthorized,
}: GroupsContentProps) => {
  const { details } = headerContent;
  const { matchDateId } = params;

  const showAdminMessage =
    isAuthorized &&
    !details.isLocked &&
    details.TotalTeamsYes > 0 &&
    ((details.scramble && details.TotalTeamsYes >= 4) ||
      (details.partnerOrSingles && details.TotalTeamsYes >= 2)) &&
    !details.isFlexLeague;
  const isRatingLeague = headerContent.details.isRatingLeague;
  const isLocked = headerContent.details.isLocked;

  const { data, isLoading } = useGetGroupsQueryData(
    matchDateId,
    details.scramble || false,
    details.partnerOrSingles || false,
    details.PoolTemplateID || 0,
    details.TotalCourts,
    currentSequenceNumber,
    isRatingLeague,
    isLocked
  );

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <Loader backgroundColor='bg-leagues-300/90' />
      </div>
    );
  }

  return (
    <div className='md:gap-3pt-11 mx-auto h-auto w-full max-w-screen-xl gap-8 md:flex lg:w-4/5'>
      <div className='maw-w-[100%] mx-auto w-full lg:w-[1283px] lg:gap-[24px]'>
        <div className='flex h-auto grow flex-col'>
          <div className='flex w-full flex-row justify-center gap-6'>
            {data?.groupsData && headerContent?.details?.isLocked ? (
              <GroupsComponent
                headerContent={headerContent}
                groupsData={data.groupsData}
                user={userSession}
                ratingSessionPlayersOnBench={data.benchGroup}
                isAuthorized={isAuthorized}
              />
            ) : (
              <div className='flex size-full flex-col items-center justify-center pt-4 text-leagues-300'>
                <div className='flex flex-col items-center gap-2'>
                  <h2 className='text-center text-base font-semibold md:text-lg lg:text-2xl'>
                    Group splits have not been generated.
                  </h2>
                  {showAdminMessage ? (
                    <p className='text-center text-xs text-leagues-300 md:text-sm lg:text-base'>
                      To generate groups, toggle “Lock Opt In/Out” to ON
                    </p>
                  ) : null}
                </div>
                <img
                  src={`${getCDNURL(`${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/padel/PL-padel.svg`, 735, 400)}`}
                  alt='Loading'
                  className='size-auto'
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupsContent;
